import React, { Component } from 'react'
import styles from  './whyus.module.css'
import 'font-awesome/css/font-awesome.min.css'
import free from './assets/free.svg'
import personalize from './assets/personalize.svg'
import expertise from './assets/expertise.svg'
import leader from './assets/leader.svg'
import { List, Container, Image, Divider, Header } from 'semantic-ui-react'

const Column = ({icon, title, description}) => {
  return (
    <div className={styles.column}>
      <div className={styles.icon}>
        <img src={icon} />
        <div className={styles.title}>{title}</div>
      </div>
      <div className={styles.about}>
        {description}
      </div>
    </div>
  );
}

const WhyUs = () => {
    const freeServiceDesc =
        "Our service is completely free. No hidden costs, no mark-ups."
    return (
    <div>
      <div className={styles.headline}><span className={styles.headlineTitle}>Why Choose University Village</span></div>
      <div className={styles.main}>
      <Column icon={free} title="Free Service" description={freeServiceDesc} />
      <Column icon={personalize} title="Personalized" description={freeServiceDesc} />
      <Column icon={expertise} title="Our Expertise" description={freeServiceDesc} />
      <Column icon={leader} title="Market Leader" description={freeServiceDesc} />
      </div>
    </div>
    );
};

const Logo = ({imgSrc, headline, subHeadline}) => {
  return <List.Item>
    <List.Content floated='right'>
    <Divider hidden fitted />
    <Header as='h3'>
      <Image size='large' src={imgSrc} className={styles.img}/>
      <Divider hidden fitted />{headline}
    </Header>
    <List.Description>{subHeadline}</List.Description>
    </List.Content>
  </List.Item>
}

const WhyUsNew = () => {
    const contents = [
      {
        headline: "FREE SERVICE",
        subHeadline: "We Provide Free Consultation",
        imgSrc: free
      },
      {
        headline: "PERSONALIZATION",
        subHeadline: "We Help You Tailor The Future",
        imgSrc: personalize
      },
      {
        headline: "EXPERTISE",
        subHeadline: "We have 20+ Years Experience",
        imgSrc: expertise
      },
      {
        headline: "Market Leader",
        subHeadline: "We Are Market Leader",
        imgSrc: leader
      }
    ];

    return (
      <Container textAlign='center'>
        <Divider hidden />
        <Divider hidden />
        <Header as='h3' dividing>WHY CHOOSE UNIVERSITY VILLAGE</Header>
        <Divider hidden />
        <Container textAlign='center'>
          <List horizontal relaxed bulleted={false}>
           {contents.map((x,i) => {
            return <Logo key={i} {...x} />
          })}
          </List>
        </Container>
          <Divider hidden />
      </Container>
    );
};


export default WhyUsNew;



// WEBPACK FOOTER //
// ./src/components/WhyUs/index.js